import { ImportantMessagesController } from '../controller/ImportantMessagesController';
import { BaseWebComponentElement } from '../../framework/BaseWebComponentElement';

export class ImportantMessagesWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: ImportantMessagesController,
    });
  }
}
